class PeggicoPersonalization extends HTMLElement {
  connectedCallback() {
    this.fileInput = this.querySelector('input[type="file"]');
    this.error = this.querySelector('[data-file-error]');
    this.fileInput?.addEventListener('change', this.validateFile);
  }

  disconnectedCallback() {
    this.fileInput?.removeEventListener('change', this.validateFile);
  }

  validateFile = () => {
    const file = this.fileInput.files?.[0];
    const maxSize = Number(this.fileInput.dataset.maxFileSize);
    const isTooLarge = file && file.size > maxSize;
    const message = isTooLarge ? this.dataset.fileSizeError : '';

    this.fileInput.setCustomValidity(message);
    this.error.textContent = message;
    this.error.hidden = !message;
  };
}

if (!customElements.get('peggico-personalization')) {
  customElements.define('peggico-personalization', PeggicoPersonalization);
}
